module.exports = __webpack_public_path__ + "media/svg/cc-bd16a37d.svg";